import { CoverageType } from "@enums";
import { object, string, mixed } from "yup";

export interface CoverageTypeFormData {
  coverageType: CoverageType;
  policyId: string;
}

export const coverageTypeFormDefaultValues: CoverageTypeFormData = {
  coverageType: CoverageType.Covertee,
  policyId: "",
};

export const coverageTypeFormValidationSchema = object({
  policyId: string().when("coverageType", {
    is: (coverageType: CoverageType) => coverageType === CoverageType.Covertee,
    then: (schema) =>
      schema
        .required("Policy ID is required.")
        .test("Digits only", "Policy ID must be digits only.", (value) => {
          if (!value) return false;
          return /^\d+$/.test(value);
        }),
    otherwise: (schema) => schema.notRequired(),
  }),
  coverageType: mixed<CoverageType>().oneOf(Object.values(CoverageType)),
});
